var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import { useStorage } from 'master-hook';
import { API_URL } from '../constants';
import { STORAGE_NAME as authStorageName } from '../use-auth';
export function makeRequest(request, access_token) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var accessToken = access_token || useStorage(authStorageName).accessToken;
    var headers = __assign({}, request.headers);
    if (accessToken) {
        headers.Authorization = "Bearer ".concat(accessToken);
    }
    // Для FormData НЕ задаём Content-Type — axios сам добавит boundary
    var url = "".concat(API_URL).concat(request.url);
    var newRequest = __assign(__assign({}, request), { url: url, headers: headers });
    return axios(newRequest).then(function (_a) {
        var data = _a.data;
        return data;
    });
}
